import React, { Fragment, useEffect, useState } from 'react'
import { Box, CardMedia, Grid, IconButton, InputLabel, Typography } from '@mui/material'
import Colors from '../../../../Assets/Styles/Colors'
import BreadCrumbs from '../../../../Components/BreadCrumbs/BreadCrumbs'
import { baseUrl } from '../../../../../axios'
import { DeleteForever, KeyboardArrowLeft, PhotoLibrary } from '@mui/icons-material'
import CategoriesServices from '../../../../Api/AdBazar/Categories/CategoriesServices'
import BannerServices from '../../../../Api/Banner/BannerServices'
import { PrimaryButton } from '../../../../Components/Buttons/index'
import { SuccessToaster } from '../../../../Components/Toaster/Toaster'
import { useNavigate } from 'react-router-dom'
import ConfirmationDialog from '../../../../Components/Dialogs/ConfirmationDialog'

function UploadBannerAb() {
  const [image, setImage] = useState("");
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [bannerImages, setBannerImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  }

  const getAllBanners = async () => {
    try {
      const result = await BannerServices.getAllBanners();
      // console.log(result);
      const filteredBanners = result?.data?.banners.filter((item) => item.type == "adbazaar");
      setBannerImages(filteredBanners);
    }
    catch (e) {
      console.log(e);
    }
  }

  const bannerImage = async () => {
    setLoading(true);
    const obj = {
      imageUrl: image,
      type: "adbazaar"
    }
    try {
      const result = await BannerServices.createBanner(obj);
      if (result.responseCode == 200) {
        SuccessToaster(result.message);
        setImage("");
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
      getAllBanners();
    }
  }

  const handleDelete = async () => {
    try {
      const result = await BannerServices.deleteBanner(id);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message);
      }
    } catch (err) {
      console.log(err)
    } finally {
      getAllBanners();
    }
  }

  useEffect(() => {
    getAllBanners();
  }, [])

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={handleDelete}
        title={"Delete Banner"}
        btn={"Delete"}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Upload Banner Image
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Upload Banner Image"]} />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          }}
        >
          <Box sx={{ mt: "20px" }}>
            <Grid item md={12}>
              <Box
                sx={{
                  height: image !== "" ? "100%" : "150px",
                  border: image !== "" ? "none" : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "4px",
                  mb: 2,
                  ":hover": {
                    borderColor: image !== "" ? "transparent" : "#1F1F1F"
                  },
                  backgroundColor: Colors.white,
                }}
              >
                {image !== "" ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "100%",
                        height: "400px",
                        objectFit: "contain"
                      }}
                    />
                  </Box>
                ) : (
                  <Fragment>
                    <InputLabel
                      htmlFor="image-input"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px"
                      }}
                    >
                      <PhotoLibrary sx={{ fontSize: "36px" }} />
                      <Typography>
                        Upload Image
                      </Typography>
                    </InputLabel>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                  </Fragment>
                )}
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <PrimaryButton
                  title={"Submit"}
                  loading={loading}
                  onClick={() => bannerImage()}
                />
              </Box>
            </Grid>
          </Box>
          <Box sx={{ backgroundColor: Colors.white, p: 2 }}>
            <Grid container spacing={3}>
              {bannerImages.map((item, i) => (
                <Grid key={i} item md={6}>
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component={"img"}
                      src={baseUrl + item.imageUrl}
                      sx={{
                        width: "100%",
                        height: "210px",
                        objectFit: "contain"
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-32px",
                        right: 0
                      }}
                    >
                      <IconButton onClick={() => { setOpen(true); setId(item?._id) }}>
                        <DeleteForever />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box >
    </Fragment>
  )
}

export default UploadBannerAb